import http from 'hub-http/clients/apiClient';
import { WEB_INTERACTIVE_TYPE_ID } from '../constants/ObjectTypeIds';
import { formatWebInteractives } from '../formatters/formatWebInteractives';
import { Map as ImmutableMap } from 'immutable';
const CRM_SEARCH_URL = 'crm-search/search';
const PAGE_SIZE = 10;
export const DEFAULT_REQUEST_PROPS = {
  count: PAGE_SIZE,
  offset: 0,
  objectTypeId: WEB_INTERACTIVE_TYPE_ID,
  requestOptions: {
    properties: ['hs_object_id', 'hs_name', 'hs_content_id', 'hs_screenshot_url', 'hs_container_type', 'hs_is_archived', 'hs_publish_state']
  },
  query: '',
  sorts: [{
    property: 'hs_created_at',
    order: 'DESC'
  }]
};
const getWebInteractiveOptions = ({
  offset,
  nameSearch,
  count
}) => {
  return Object.assign({}, DEFAULT_REQUEST_PROPS, {
    count,
    offset,
    query: nameSearch
  });
};
export const createFetchByIds = ({
  httpClient
}) => ids => httpClient.post(CRM_SEARCH_URL, {
  data: Object.assign({}, getWebInteractiveOptions({
    count: PAGE_SIZE,
    offset: 0,
    nameSearch: ''
  }), {
    filterGroups: [{
      filters: [{
        operator: 'IN',
        property: 'hs_object_id',
        values: ids
      }]
    }]
  })
}).then(res => formatWebInteractives(res).get('results'));
export const fetchByIds = createFetchByIds({
  httpClient: http
});
const DEFAULT_PROPS = {
  count: PAGE_SIZE,
  query: '',
  offset: 0
};
export const createSearchWebInteractives = ({
  httpClient
}) => (props = ImmutableMap(DEFAULT_PROPS)) => {
  const {
    count,
    offset,
    query
  } = props.toJS();
  return httpClient.post(CRM_SEARCH_URL, {
    data: getWebInteractiveOptions({
      count,
      offset,
      nameSearch: query
    })
  }).then(formatWebInteractives);
};
export const searchWebInteractives = createSearchWebInteractives({
  httpClient: http
});